import React, { createContext, useContext, useMemo } from 'react';
import { NODE_TYPES } from '@containers/flow/nodes';

const FlowAgentContext = createContext({
  planStepIds: [],
  isEditable: true,
  hasQueryNode: false,
});

export const useFlowAgentContext = () => {
  const context = useContext(FlowAgentContext);
  if (!context) {
    throw new Error('useFlowAgentContext must be used within a FlowAgentProvider');
  }
  return context;
};

export const usePlanStepIds = () => {
  const { planStepIds } = useFlowAgentContext();
  return planStepIds;
};

export const useIsAgentScriptEditable = () => {
  const { isEditable } = useFlowAgentContext();
  return isEditable;
};

export const useHasQueryNode = () => {
  const { hasQueryNode } = useFlowAgentContext();
  return hasQueryNode;
};

export const FlowAgentProvider = ({ children, nodes = [], isEditable = true }) => {
  const planStepIds = useMemo(() => {
    return nodes
      .filter((node) => node.type === NODE_TYPES.PlanStepNode && node.data?.planStepData?.step_id)
      .map((node) => node.data.planStepData.step_id);
  }, [nodes]);

  const hasQueryNode = useMemo(() => nodes.some((node) => node.type === NODE_TYPES.AgentScriptQueryNode), [nodes]);

  const value = useMemo(
    () => ({
      planStepIds,
      isEditable,
      hasQueryNode,
    }),
    [planStepIds, isEditable, hasQueryNode]
  );

  return <FlowAgentContext.Provider value={value}>{children}</FlowAgentContext.Provider>;
};

export default FlowAgentContext;
